import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';

export default function LegalPage({ src }) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    fetch(src)
      .then(r => r.text())
      .then(setHtml)
      .catch(() => setHtml('<p>Не удалось загрузить страницу.</p>'));
  }, [src]);

  return (
    <>
      <PageHeader />
      <Box
        dangerouslySetInnerHTML={{ __html: html }}
        sx={{ maxWidth: 800, mx: 'auto', mt: 4, px: 3, pb: 6 }}
      />
    </>
  );
}
